import React from 'react';
import { BadgeCheck } from 'lucide-react';
import SubjectPageLayout from '../components/SubjectPageLayout';
import LojaDaten, { DATEN_LINES, DATEN_STORE_URL } from '../components/LojaDaten';

const SITE = 'https://fernandotech.com.br';

const SCHEMA = {
  "@type": "Store",
  "@id": `${SITE}/loja-daten#store`,
  "name": "Loja Daten — Fernando Tech (Revenda e Assistência Autorizada)",
  "url": `${SITE}/loja-daten`,
  "image": `${SITE}/logo-daten.jpg`,
  "telephone": "+55-16-99137-8312",
  "priceRange": "R$ 1.600 – R$ 12.000",
  "address": { "@type": "PostalAddress", "addressLocality": "Ribeirão Preto", "addressRegion": "SP", "addressCountry": "BR" },
  "areaServed": "Brasil",
  "brand": { "@type": "Brand", "name": "Daten Tecnologia", "url": DATEN_STORE_URL },
  "parentOrganization": { "@id": `${SITE}/#organization-extended` },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Linha Daten",
    "itemListElement": DATEN_LINES.map(l => ({
      "@type": "Offer",
      "availability": "https://schema.org/InStock",
      "priceCurrency": "BRL",
      "url": `${SITE}/loja-daten`,
      "itemOffered": { "@type": "Product", "name": l.name, "description": l.desc, "brand": { "@type": "Brand", "name": "Daten" } },
    })),
  },
};

const FAQ = [
  { q: "A Fernando Tech é revenda autorizada Daten?", a: "Sim. Somos revenda, afiliado e assistência técnica autorizada Daten Tecnologia em Ribeirão Preto e região, atendendo empresas, escolas, órgãos públicos e consumidores finais em todo o Brasil." },
  { q: "Quais produtos Daten posso comprar com a Fernando Tech?", a: "Notebooks, desktops, mini PCs, all in one, monitores e acessórios Daten. Indicamos a configuração ideal para o seu uso e enviamos a cotação pelo WhatsApp." },
  { q: "Qual a vantagem de comprar Daten pela Fernando Tech em vez da loja online?", a: "Você paga o mesmo preço de fábrica e ganha suporte local: configuração inicial, instalação, migração de dados, garantia e assistência técnica autorizada sem precisar enviar o equipamento para fora da cidade." },
  { q: "Os equipamentos Daten servem para licitações e órgãos públicos?", a: "Sim. A Daten é referência no setor público brasileiro, com equipamentos homologados, Windows 11 Pro, TPM 2.0 e garantia nacional." },
  { q: "A Fernando Tech faz manutenção de notebooks e desktops Daten na garantia?", a: "Sim. Como assistência técnica autorizada Daten, realizamos atendimento em garantia e fora de garantia em Ribeirão Preto e região." },
  { q: "Como faço para comprar ou cotar um Daten?", a: "Clique em 'Comprar Daten pelo WhatsApp' ou use o botão 'Me ligue agora' que a Fernando Tech entra em contato com você por telefone (16) 3237-1003 ou WhatsApp." },
];

export default function LojaDatenPage() {
  return (
    <SubjectPageLayout
      path="/loja-daten"
      breadcrumbName="Loja Daten"
      breadcrumbIcon={<BadgeCheck className="w-3.5 h-3.5" />}
      seoTitle="Loja Daten Ribeirão Preto | Notebooks, Desktops e Mini PCs com Assistência Autorizada | Fernando Tech"
      seoDescription="Compre notebooks, desktops, mini PCs e all in one Daten com a Fernando Tech: revenda, afiliado e assistência técnica autorizada Daten em Ribeirão Preto. Preço de fábrica + suporte local. Cote pelo WhatsApp."
      extraSchema={SCHEMA}
      faq={FAQ}
      hero={{
        badge: 'Revenda · Afiliado · Assistência Autorizada Daten',
        badgeIcon: <BadgeCheck className="w-3.5 h-3.5" />,
        title: 'Loja Daten',
        accent: 'preço de fábrica, suporte da Fernando Tech',
        subtitle: 'Notebooks, desktops, mini PCs e all in one Daten para empresas, escolas, órgãos públicos e você — com quem entende de TI e dá assistência técnica autorizada em Ribeirão Preto.',
      }}
      cta={{
        heading: 'Quer um orçamento Daten agora?',
        text: 'Fale com a Fernando Tech pelo WhatsApp ou deixe seu nome que nós ligamos para você. Indicamos a configuração ideal e cuidamos de tudo: compra, configuração e suporte.',
        primary: { label: 'Cotar Daten no WhatsApp', href: 'https://wa.me/5516991378312?text=' + encodeURIComponent('Olá! Quero uma cotação de equipamentos Daten com a Fernando Tech.') },
        secondary: { label: 'Ver linha gamer Navegamer', to: '/navegamer' },
      }}
    >
      <LojaDaten />
    </SubjectPageLayout>
  );
}
